import React from 'react';
import PropTypes from 'prop-types';
import BasicPageOptionButton from 'components/admin/basic/BasicPageOptionButton';
import ResultPageButton from 'components/admin/result/ResultPageButton';


const EventResultPageOptionButton = ({
  showPublishButton,
  showEditResultButton = true,
  showEditEventButton = true,
  isAdd = false,
  buttonDisabled,
  handlePublishResult,
  handleEditResult,
  handleEditEvent,
  centerTitle,
}) => {
  return (
    <BasicPageOptionButton
      buttonChild={
        <ResultPageButton
          showPublishButton={showPublishButton}
          showEditResultButton={showEditResultButton}
          showEditEventButton={showEditEventButton}
          isAdd={isAdd}
          buttonDisabled={buttonDisabled}
          handlePublishResult={handlePublishResult}
          handleEditResult={handleEditResult}
          handleEditEvent={handleEditEvent}
        />
      }
      centerTitle={centerTitle}
    />
  );
};

EventResultPageOptionButton.propTypes = {
  showPublishButton: PropTypes.bool,
  showEditResultButton: PropTypes.bool,
  showEditEventButton: PropTypes.bool,
  isAdd: PropTypes.bool,
  buttonDisabled: PropTypes.bool,
  handlePublishResult: PropTypes.func,
  handleEditResult: PropTypes.func,
  handleEditEvent: PropTypes.func,
  centerTitle: PropTypes.string,
};

export default EventResultPageOptionButton;
